export default "__VITE_ASSET__5cf30da5__"